import { TabPanel, Tabs } from '@/components';
import { enumObject } from '@/utils';
import { useTranslation } from 'react-i18next';
import { HomeAttachments } from './HomeAttachments';
import styles from './HomeAttachmentsTabContent.module.scss';
import { HomeCommunityAttachments } from './HomeCommunityAttachments';
import { HomeFloorplanAttachments } from './HomeFloorplanAttachments';

const { TabPane } = Tabs;

const TAB_KEYS = ['home', 'community', 'floorplan'];

const HomeAttachmentsTabContentKeys = enumObject(
  'HomeAttachmentsTabContentKeys',
  TAB_KEYS,
);

interface Props {
  id: string;
  communityId: string;
  floorplanId?: string;
}

export const HomeAttachmentsTabContent = (props: Props) => {
  const { id, communityId, floorplanId } = props;
  const { t } = useTranslation();

  return (
    <Tabs
      tabKeys={HomeAttachmentsTabContentKeys}
      destroyInactiveTabPane
      defaultActiveKey={HomeAttachmentsTabContentKeys['home']}
    >
      <TabPane
        tab={t('homes.details.documents.home')}
        key={HomeAttachmentsTabContentKeys['home']}
      >
        <TabPanel>
          <TabPanel.Body>
            <HomeAttachments className={styles.attachment} key={id} id={id} />
          </TabPanel.Body>
        </TabPanel>
      </TabPane>

      <TabPane
        tab={t('homes.details.documents.community')}
        key={HomeAttachmentsTabContentKeys['community']}
      >
        <TabPanel>
          <TabPanel.Body>
            <HomeCommunityAttachments
              className={styles.attachment}
              communityId={communityId}
            />
          </TabPanel.Body>
        </TabPanel>
      </TabPane>

      {floorplanId && (
        <TabPane
          tab={t('homes.details.documents.floorplan')}
          key={HomeAttachmentsTabContentKeys['floorplan']}
        >
          <TabPanel>
            <TabPanel.Body>
              <HomeFloorplanAttachments
                floorplanId={floorplanId}
                className={styles.attachment}
              />
            </TabPanel.Body>
          </TabPanel>
        </TabPane>
      )}
    </Tabs>
  );
};
